<template>
  <header :class="[scrollPosition >= 50 ? 'smallHeader' : '']">
    <div
      class="mobileNav"
      v-if="screenWidth < screenBreakLG"
      :class="navOpen ? 'open' : ''"
    >
      <ToggleBurger />
      <nav v-if="navOpen">
        <router-link :to="{ path: `/${$t('biography').toLowerCase()}` }">{{
          $t("biography")
        }}</router-link>
        <router-link :to="{ path: `/${$t('productions').toLowerCase()}` }">{{
          $t("productions")
        }}</router-link>
        <router-link :to="{ path: `/${$t('awards').toLowerCase()}` }">{{
          $t("awards")
        }}</router-link>
        <router-link :to="{ path: `/${$t('contact').toLowerCase()}` }">{{
          $t("contact")
        }}</router-link>
        <LanguageBox
          style="width: 85%; margin-right: 2rem; text-align: right"
        />
        <div class="socialMediaBox mobile" v-if="screenWidth <= screenBreakLG">
          <a
            href="https://www.facebook.com/Michael.Bully.Herbig/"
            target="_blank"
            ><img src="@/assets/icons/facebook.svg" alt="Facebook Icon"
          /></a>
          <a href="https://www.instagram.com/bullyherbig/" target="_blank"
            ><img src="@/assets/icons/instagram.svg" alt="Instagram Icon"
          /></a>
          <a href="https://www.youtube.com/@michaelbullyherbig" target="_blank"
            ><img src="@/assets/icons/youtube.svg" alt="Youtube Icon"
          /></a>
        </div>
      </nav>
    </div>
    <div class="text-center">
      <div class="row">
        <div class="col-1"></div>
        <div class="col-10">
          <div class="row">
            <div class="col-5">
              <div class="row navLine" v-if="screenWidth > screenBreakLG">
                <div class="col-6">
                  <router-link
                    :to="{ path: `/${$t('biography').toLowerCase()}` }"
                    >{{ $t("biography") }}</router-link
                  >
                </div>
                <div class="col-6">
                  <router-link
                    :to="{ path: `/${$t('productions').toLowerCase()}` }"
                    >{{ $t("productions") }}</router-link
                  >
                </div>
              </div>
            </div>
            <div
              class="col-2 d-flex justify-content-center align-items-center"
              style="text-align: center"
            >
              <img
                class="logo"
                aria-label="Logo Michael Bully Herbig"
                src="@/assets/images/Logo_Bully_weiss_line.svg"
                alt="Logo Michael Bully Herbig"
                @click="$router.push({ name: 'home' })"
                @dblclick="$router.push({ name: 'home' })"
                @keypress.enter.prevent="$router.push({ name: 'home' })"
                tabindex="0"
              />
              <!--<div
                class="mbhLogo"
                @click="$router.push({ name: 'home' })"
                @dblclick="$router.push({ name: 'home' })"
                @keypress.enter.prevent="$router.push({ name: 'home' })"
              >
                MBH
              </div>-->
            </div>

            <div class="col-5 navLine" v-if="screenWidth > screenBreakLG">
              <div class="row">
                <div class="col-6">
                  <router-link
                    :to="{ path: `/${$t('awards').toLowerCase()}` }"
                    >{{ $t("awards") }}</router-link
                  >
                </div>
                <div class="col-6">
                  <router-link
                    :to="{ path: `/${$t('contact').toLowerCase()}` }"
                    >{{ $t("contact") }}</router-link
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <LanguageBox
          :style="`margin-top:${scrollPosition >= 50 ? '1.4' : '3'}rem`"
          v-if="screenWidth > screenBreakLG"
        />
      </div>
    </div>
  </header>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "HeaderPart",
  components: {
    ToggleBurger: () => import("@/components/ToggleBurger.vue"),
    LanguageBox: () => import("@/components/templateParts/LanguageBox.vue"),
  },
  computed: {
    ...mapState([
      "cmsUrl",
      "screenWidth",
      "screenBreakLG",
      "scrollPosition",
      "curLang",
      "navOpen",
    ]),
  },
};
</script>

<style lang="sass">
@import '@/assets/sass/main.sass'
header
  position: fixed
  top: 0
  right: 0
  width: 100%
  background-color: rgba(black, 1)
  height: 110px
  z-index: 10
  box-shadow: 5px 0 20px 5px rgba(black, .8)
  transition: height .0s
  @media (max-width: $breakPointLG)
    height: 75px
    .logo
      height: 60px !important
      margin-top: .3rem !important
  .logo
    height: 110%
    margin-top: 1.2rem
    cursor: pointer
    transition: .6s
    max-width: 185px
  a
    @include border-bottom-hover($gold, $lightgrey)
    font-family: 'Mainfont-Bold'
    color: white !important
    font-size: 1rem
    transition: color .8s, transform .8s, font-size .8s
    &.router-link-exact-active
      color: $gold !important
  .navLine
    padding-top: 3rem
    transition: padding .8s
  .languageBox
    color: white
    text-align: left
    transition: margin .8s
    cursor: pointer
    .lang
      display: inline-block
      transition: .8s
      font-size: .9rem
      &:hover
        color: white
        box-shadow: 0 0 25px 0 hsla(0, 0%, 100%, .8)
        background-color: rgba(white, .2)
        border-radius: 50%
        transform: scale(1.2)
    .active
      color: $gold
      transform: scale(1.25)
      font-family: 'Mainfont-Bold'
      &:hover
        color: $gold
  &.smallHeader
    height: 65px
    transition: .8s
    .logo
      margin-top: .5rem
      height: 55px
    .navLine
      padding-top: 1.5rem
      a
        font-size: 1rem
    .languageBox
      margin-top: 1.5rem
  .mobileNav
    width: 2.5rem
    height: 2.5rem
    position: absolute
    top: 0
    right: 0
    transition: .8s
    &.open
      width: 85vw
      max-width: 450px
      height: 90vh
      background-color: rgba(black, .9)
      nav
        margin-top: 18vh
        a
          margin-bottom: .8rem
          margin-left: 10vw
          display: block
          font-size: 1.2rem
          color: white
          &:hover
            color: white
            transform: scale(1)
</style>
